export const QueryKeys = {
    GetAllOrderHistoryItems: 'get-all-history-items',
}
